import styled from "styled-components";

const CardContainer = styled.div`
height: 100%;
position: relative;
`
export default CardContainer